const contact = {
  eyebrow: 'Get in touch',
  title: "Let's work together",
  lead:
    "Building something with AI, need a product shipped, or just want to talk shop? I'm always up for an interesting problem.",
  emailMe: 'Email me',
  book: 'Book 30 min',
  callMe: 'Call me',
  directEmail: 'Email',
  directOr: 'or call',
};

export default contact;
